import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
import FunctionsContext from './FunctionsContext';
import FunctionsListHeader from './FunctionsListHeader';

class FunctionsList extends React.Component {
    
    static contextType = FunctionsContext;

    handleFunctionClick = (aFunction) => {
        // Add safety check for context and methods
        if (!this.context || !this.context.selectFunction) {
            return;
        }
        this.context.selectFunction(aFunction);
        this.context.setSelectedWorkflowStep('');
    };

    render()
    {
        return(
            <List>
            <ListItem divider>
                <FunctionsListHeader/>
            </ListItem> 
            {this.context.functions.functions && this.context.functions.functions.map(aFunction => 
            <ListItem
                key={aFunction.id}
                divider
                selected={this.context.functions.selectedFunction && aFunction.id === this.context.functions.selectedFunction.id} 
                button
                onClick={() => this.handleFunctionClick(aFunction)}
            >
                <ListItemText primary={aFunction.name} />
            </ListItem>)}
        </List>)    }
}

export default FunctionsList;